export default "__VITE_ASSET__e968b46a__"